import Cookies from 'js-cookie';
import { getBaseQuery, getBaseUrl } from '../../Utils';
import { createApi } from '@reduxjs/toolkit/query/react';
import { FoundationsConstants } from '../../FoundationsConstants';
export interface SavedValue {
  DisplayText: any;
  KeyValue: number;
  name: string;
}
export interface SavedValues {
  [key: string]: SavedValue[];
}
export interface UserRole {
  Id: string;
  Name: string;
}
export interface SavedAttributes {
  userId: number;
  userSavedAttributes: Array<{
    MetaDataId: number;
    DisplayText: string;
    [key: string]: any;
  }>;
}
export interface UserSavedAttributes {
  MetaDataId: number;
  DisplayText: string;
  [key: string]: any;
}
 export interface User {
    Id: string;
    FullName: string;
    EmailAddress: string;
    PrimaryRole: { Id: string; Name: string };
    FirstName: string
    LastName: string
    OrganizationName: string
    NationalProviderID: string
    DeveloperMode?: boolean
  }
 export interface UserWithRole extends User {  // Extending User
    PrimaryRole: { Id: string; Name: string };
}
export interface UsersbyStatus {
    userStatus: string;
    userRole?: string;
    userSearchField?: string;
    userSearch?: string;
    userLocation?: string;
    usersData?: (User | UserWithRole)[];   
}
export interface AttributesValues {
  listname: string;
  listid: number;
  filtertext?: string; // Optional field
}
export interface Delete{
  userId: number;
  comment:string;
}
export interface Reject{
  userId: number;
  comment:string;
}
export interface ForceSignOut{
  userId: number;
}

export interface save {
  metaDataId: number;
  KeyValues: string[];
  managerAttribute: boolean;
  showInUserSettings: boolean;
}
export interface saveApprove{
  userId: number;
  roleId: number;
  groupId: number;
  nationalProviderID: string;
  organizationName: string;
  makePowerUser: boolean;
  allowDataExport: boolean;
  allowPatientLookup: boolean;
  allowDataFix: boolean;
  allowUserNote: boolean;
  allowActivePanel: boolean;
  comment: string;
  providerId: number; 
  userNewStatus: number;
  attributes:save[];
}
const baseUrl = `${getBaseUrl()}/API/v3`;
 
export const ManageUsersApi = createApi({
  reducerPath: 'ManageUsersApi',
  baseQuery: getBaseQuery(baseUrl),
  endpoints: (builder) => ({
    // Existing mutation for fetching users by status
    UsersbyStatus: builder.mutation<any, UsersbyStatus>({
      query: (params) => ({
        url: '/ManageUsers/UsersbyStatus',
        method: 'POST',
        body: params, // Send the parameters in the body
      }),
      transformResponse: (response: any) => {
        return response.data ? response.data : [];
      },
    }),
 
    // GetRole
    GetRoles: builder.mutation<any, void>({
      query: () => ({
        url: '/ManageUsers/GetRoles',
        method: 'GET',
      }),
      transformResponse: (response: any) => {
        return response.data ? response.data : [];
      },
    }),
 
    //SavedAttributes
    SavedAttributes: builder.mutation<any, { userId: number }>({
        query: ({ userId }) => ({
          url: `/ManageUsers/SavedAttributes?UserId=${userId}`, // Pass UserId as query parameter
          method: 'GET',
        }),
        transformResponse: (response: any) => {
          return response.data ? response.data : [];
        },
      }),
 
      //Attribute
      Attribute:builder.mutation<any, void>({
        query: (params) => ({
          url: '/ManageUsers/User/Attributes',
          method: 'POST',
          body: params, // Send the parameters in the body
        }),
        transformResponse: (response: any) => {
          return response.data ? response.data : [];
        },
      }),
 
      //AttributesValues
      AttributesValues: builder.mutation<any, AttributesValues>({
        query: (params) => {
          // Create FormData object
          const formData = new FormData();
          formData.append('listname', params.listname); // Append listname
          formData.append('listid', String(params.listid)); // Convert listid to string and append
          if (params.filtertext) {
            formData.append('filtertext', params.filtertext); // Append filtertext if it exists
          }     
          return {
            url: '/ManageUsers/User/AttributesValues',
            method: 'POST',
            body: formData, // Send FormData as body
          };
        },
        transformResponse: (response: any) => {
          return response.data ? response.data : [];
        },
      }),
     
 
      //Delete
      Delete: builder.mutation<any, Delete>({
        query: (params) => {
          const formData = new FormData();
          formData.append('userId', String(params.userId)); // Append userId to FormData
          formData.append('comment', String(params.comment));    
          return {
            url: '/ManageUsers',
            method: 'DELETE',
            body: formData, // Use FormData as the body
          };
        },
        transformResponse: (response: any) => {
          return response.data ? response.data : [];
        },
      }),

      //reject
      Reject: builder.mutation<any, Reject>({
        query: (params) => {
          const formData = new FormData();
          formData.append('userId', String(params.userId)); // Append userId to FormData
          formData.append('comment',String(params.comment));    
          return {
            url: '/ManageUsers/RejectUserAccount',
            method: 'Put',
            body: formData, // Use FormData as the body
          };
        },
        transformResponse: (response: any) => {
          return response.data ? response.data : [];
        },
      }),

      //ProxyUser
      ProxyUser: builder.mutation<any, any>({
        query: (proxyUserId) => ({
            url: '/Proxy/SwitchToProxyUser',
            method: 'POST',
            body:proxyUserId
        }),
    }),

     //Force SignOut
     ForceSignOut: builder.mutation<any, ForceSignOut>({
      query: (params) => {
        const formData = new FormData();
        formData.append('userId', String(params.userId)); // Append userId to FormData
        return {
          url: '/Users/InvalidateSession',
          method: 'POST',
          body: formData, // Use FormData as the body
        };
      },
      transformResponse: (response: any) => {
        return response ? response : [];
      },
    }),

    //SavePasswords
    SavePasswordSettings: builder.mutation<any, any>({
      query: (passwordData) => ({
          url: '/ManageUsers/ChangePassword',
          method: 'PUT',
          body: passwordData,
      }),
  }),

  ResetRelasePopup: builder.mutation<any, void>({
      query: () => {
        return {
          url: `Users/ResetRelasePopup`,
          method: 'POST',
          headers: {
            'hl-user-token': Cookies.get(FoundationsConstants.TOKEN_STR)  || '',
          },
        };
      },
    }),

  //Approve Save
  ApproveSave: builder.mutation<any, saveApprove>({
    query: (params) => {
      const formData = new FormData();
  
      // Append other fields from saveApprove to FormData
      formData.append('userId', String(params.userId));
      formData.append('roleId', String(params.roleId));
      formData.append('groupId', String(params.groupId));
      formData.append('nationalProviderID', params.nationalProviderID);
      formData.append('organizationName', params.organizationName);
      formData.append('makePowerUser', String(params.makePowerUser));
      formData.append('allowDataExport', String(params.allowDataExport));
      formData.append('allowPatientLookup', String(params.allowPatientLookup));
      formData.append('allowDataFix', String(params.allowDataFix));
      formData.append('allowUserNote', String(params.allowUserNote));
      formData.append('allowActivePanel', String(params.allowActivePanel));
      formData.append('providerId', String(params.providerId));
      formData.append('comment', params.comment);
      formData.append('userNewStatus', String(params.userNewStatus));
  
      // Loop through the attributes array and append each attribute
      params.attributes.forEach((attribute, index) => {
        formData.append(`attributes[${index}].metaDataId`, String(attribute.metaDataId));
        
        // Append KeyValues if they exist (handle array within each attribute)
        attribute.KeyValues.forEach((keyValue, keyIndex) => {
          formData.append(`attributes[${index}].KeyValues[${keyIndex}]`, String(keyValue));
        });
  
        formData.append(`attributes[${index}].managerAttribute`, String(attribute.managerAttribute));
        formData.append(`attributes[${index}].showInUserSettings`, String(attribute.showInUserSettings));
      });
  
      return {
        url: '/ManageUsers',
        method: 'PUT',
        body: formData,
      };
    },
    transformResponse: (response: any) => {
      return response.data ? response.data : [];
    },
  }),
  }),
});
 
// Export the hooks for the API endpoints
export const { useUsersbyStatusMutation, useGetRolesMutation, useSavedAttributesMutation, useAttributeMutation, useAttributesValuesMutation, useDeleteMutation, useRejectMutation, useProxyUserMutation, useForceSignOutMutation, useSavePasswordSettingsMutation, useApproveSaveMutation, useResetRelasePopupMutation } = ManageUsersApi;
 